import { Link as RLink } from "react-router-dom";
import { Link } from "@chakra-ui/react";
import { forwardRef } from "react";

const Linker = forwardRef(({ children, ...props }: any, ref) => {
  return (
    <Link as={RLink} _hover={{ textDecoration: "none" }} ref={ref} {...props}>
      {children}
    </Link>
  );
});

Linker.displayName = "Linker"; // Good practice to add display name for debugging

export default Linker;
